module.exports = import("@wordpress/a11y");;